export default "__VITE_ASSET__40b35087__"